import React from 'react';
import { Alert, Card, Row, Col } from '@/components/ui';
import { Vehicle } from '../../../types/Vehicle';

interface VehicleTechnicalSettingsSectionProps {
  vehicle: Vehicle;
  onUpdate: (vehicle: Vehicle) => void;
  canEdit: boolean;
}

const VehicleTechnicalSettingsSection: React.FC<VehicleTechnicalSettingsSectionProps> = ({ vehicle }) => {

  return (
    <div>
      <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <h2>Technical Settings</h2>
      </div>

      <Alert variant="info">
        <p className="tw-mb-0">
          <i className="bi bi-info-circle tw-mr-2"></i>
          Vehicle profile management has been moved to the <strong>Vehicle Profiles</strong> page in the Admin menu.
          You can assign a profile to this vehicle in the <strong>About</strong> section under Technical Information.
        </p>
      </Alert>

      {vehicle.vehicleProfile && (
        <Card>
          <Card.Header>
            <h5>Current Profile: {vehicle.vehicleProfile.inspection}</h5>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={6}>
                <p><strong>Vehicle Type:</strong> {vehicle.vehicleProfile.vehicleType || '-'}</p>
                <p><strong>Vehicle Classification:</strong> {vehicle.vehicleProfile.vehicleClassification || '-'}</p>
                <p><strong>PM Classification:</strong> {vehicle.vehicleProfile.pmClassification || '-'}</p>
                <p><strong>Odometer Alerts:</strong> {vehicle.vehicleProfile.odometerAlerts || '-'}</p>
                <p><strong>Mandatory Odometer Picture:</strong> {vehicle.vehicleProfile.mandatoryOdometerPicture ? 'Yes' : 'No'}</p>
                <p><strong>Requires CVI Expiry Date:</strong> {vehicle.vehicleProfile.requiresCVIExpiryDate ? 'Yes' : 'No'}</p>
              </Col>
              <Col md={6}>
                <p><strong>Requires Odometer Reading:</strong> {vehicle.vehicleProfile.requiresOdometerReading ? 'Yes' : 'No'}</p>
                <p><strong>Requires Brake Inspection:</strong> {vehicle.vehicleProfile.requiresBrakeInspection ? 'Yes' : 'No'}</p>
                <p><strong>Requires Post-trip:</strong> {vehicle.vehicleProfile.requiresPostTrip ? 'Yes' : 'No'}</p>
                <p><strong>Requires Foreman Approval:</strong> {vehicle.vehicleProfile.requiresForemanApproval ? 'Yes' : 'No'}</p>
                <p><strong>Requires Mech Supervisor Approval:</strong> {vehicle.vehicleProfile.requiresMechSupervisorApproval ? 'Yes' : 'No'}</p>
                <p><strong>Post-trip Threshold:</strong> {vehicle.vehicleProfile.postTripThreshold || '-'}</p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default VehicleTechnicalSettingsSection;

